import List from "@/components/list";

const Table = (args) => {
  const { listeners } = args;
  const moveMember = listeners["moveMember"] || function () { };
  const RCSelectionChange = listeners["selection-change"] || function () { };

  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    const dealConf = [
      ["icon-remove", "移动", () => moveMember(item), ""]
    ];

    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top">
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "所在班级",
      prop: "className",
      width: "100",
      showOverflowTooltip: true,
    },
    {
      label: "姓名",
      prop: "userName",
      width: "80",
      showOverflowTooltip: true,
    },
    {
      label: "工作单位",
      prop: "deptName",
      minWidth: "150",
      showOverflowTooltip: true,
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "150",
      showOverflowTooltip: true,
    },
    {
      label: "操作",
      fixed: "right",
      width: "80",
      render: (vo) => <Deal vo={vo} />,
    }
  ]

  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
}

export default Table;